
import { Vue, Component } from 'vue-property-decorator'
import Header from "@/components/Header.vue"

@Component({
  components: {
    Header
  }
})
export default class App extends Vue {
  // The live (production) build of this app, linked from the staging banner.
  protected liveAuthLink =
    process.env.VUE_APP_PROD_AUTH_LINK || 'https://auth.frankford.co'

  get staging(): boolean {
    if (process.env.VUE_APP_ENV === "staging") {
      return true;
    } else {
      return false;
    }
  }
}
